import { render, staticRenderFns } from "./AktivitaetModal.vue?vue&type=template&id=30767907&scoped=true"
import script from "./AktivitaetModal.vue?vue&type=script&lang=js"
export * from "./AktivitaetModal.vue?vue&type=script&lang=js"
import style0 from "./AktivitaetModal.vue?vue&type=style&index=0&id=30767907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30767907",
  null
  
)

export default component.exports